import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M16.001 0C24.837 0 32 7.163 32 16s-7.163 16-16 16S0 24.837 0 16 7.163 0 16.001 0zM16 22a1.5 1.5 0 100 3 1.5 1.5 0 000-3zm.5-15.5c-3.032 0-5.02 1.49-5.48 4.253a1.5 1.5 0 102.96.494c.206-1.237.885-1.747 2.52-1.747 1.875 0 2.5.833 2.5 2 0 1.037-.27 1.378-1.582 2.252-2.063 1.376-2.918 2.452-2.918 4.748a1.5 1.5 0 003 0c0-1.037.27-1.378 1.582-2.252C21.145 14.872 22 13.796 22 11.5c0-2.667-1.75-5-5.5-5z",
  fill: "#262626",
  fillRule: "evenodd"
});

var SvgSupportLarge = function SvgSupportLarge(props) {
  return React.createElement("svg", props, _ref);
};

export default SvgSupportLarge;